exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#PermissionDescribe {\n  padding: 0.16rem;\n  font-size: 0.15rem;\n  color: #1E283C;\n  width: 100%;\n}\n#PermissionDescribe h2 {\n  font-size: 0.18rem;\n}\n#PermissionDescribe h3 {\n  margin: 0.05rem 0;\n  font-size: 0.15rem;\n}\n#PermissionDescribe section {\n  margin: 0.12rem 0;\n  width: 100%;\n}\n#PermissionDescribe .table1 {\n  width: 600px;\n  display: table;\n  border-collapse: collapse;\n}\n#PermissionDescribe .table1 .table-view {\n  display: table-row;\n}\n#PermissionDescribe .table1 .table-view .table-clumn {\n  display: table-cell;\n  word-wrap: break-word;\n  overflow: hidden;\n  vertical-align: middle;\n  border: 1px solid #333;\n  word-break: break-all;\n  min-width: .5rem;\n}\n#PermissionDescribe .scorll-view {\n  overflow-x: auto;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/permissionDescribe/index.less
// module id = 422
// module chunks = 0